export const enum FaqsTypeEnum {
  GeneralFaq = "3001",
  ProjectFaq = "3002",
}
